import UserPanelMeditasyon from "@/pages/UserPanelMeditasyon";

export default function UserPanelNefes() {
  return <UserPanelMeditasyon mode="breath" forcedTag="nefes" />;
}
